import { render, staticRenderFns } from "./TwoColumnsBanner.vue?vue&type=template&id=1cd6dc40&"
import script from "./TwoColumnsBanner.vue?vue&type=script&lang=js&"
export * from "./TwoColumnsBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports